import { Grid, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { DetailTable } from "../../../../components/detail_table";
import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IBudget } from "../../data/entities";
import { budgetRedux } from "../state/state";

export const BudgetDetailPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const { id } = match.params;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(budgetRedux.actions.getDetail(id));
  }, [dispatch, id]);
  const budgetDetailBranch = useSelector<IAppReduxState, IAsyncData<IBudget>>((state) => state.budget.details);

  const deleteBudget = async (id: string): Promise<void> => {
    await dispatch(budgetRedux.actions.delete(id));
    history.push(ROUTES.budget);
  };
  const deleteBranch = useSelector<IAppReduxState, IAsyncData<void>>((state) => state.budget.delete);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <DetailTable
          branch={budgetDetailBranch}
          route={ROUTES.budget}
          onDelete={deleteBudget}
          deleteBranch={deleteBranch}
        >
          <Table size="medium" className="detail-table">
            <TableBody>
              <TableRow>
                <TableCell>Amount</TableCell>
                <TableCell>{budgetDetailBranch.data?.amount}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DetailTable>
      </Grid>
    </Grid>
  );
};
